import {FC, useState} from 'react'
import {Alert, Button, Form, Spinner} from 'react-bootstrap'

type WebhookSecurityProps = {
  username: string
  setUsername: (username: string) => void
  password: string
  setPassword: (password: string) => void
  error: string
  fetchLoading: boolean
  writeLoading: boolean
  handleSubmit: () => void
}

const WebhookSecurity: FC<WebhookSecurityProps> = (props) => {
  const {
    error,
    fetchLoading,
    writeLoading,
    username,
    setUsername,
    password,
    setPassword,
    handleSubmit,
  } = props
  const [showPassword, setShowPassword] = useState(false)

  const isCreate = username === '' && password === ''

  return (
    <div className='card mb-10'>
      <div className='card-header'>
        <div className='card-title'>
          <h3 className='fs-2'>Webhook Logins</h3>
        </div>
      </div>
      <div className='card-body p-0'>
        {fetchLoading ? (
          <div className='d-flex justify-content-center m-10 h-50px'>
            <Spinner />
          </div>
        ) : (
          <>
            <div className='card-toolbar align-items-center'>
              <div className='p-10 pb-0'>
                {error !== '' ? (
                  <Alert variant='danger'>{error} </Alert>
                ) : (
                  <Alert>
                    For now, we only support authentication using the basic auth method.
                  </Alert>
                )}
              </div>
            </div>
            <div className='p-10 pt-0'>
              <Form.Group controlId='username' className='pb-5'>
                <Form.Label>Username</Form.Label>
                <Form.Control
                  data-testid='inputUsernameWebhookSecurity'
                  type='text'
                  placeholder='Enter your username'
                  name='username'
                  value={username}
                  onChange={(e) => setUsername(e.currentTarget.value)}
                />
              </Form.Group>
              <Form.Group controlId='password' className='pb-5'>
                <Form.Label>Password</Form.Label>
                <div className='password-wrap'>
                  <input
                    data-testid='inputPasswordWebhookSecurity'
                    type={!showPassword && !isCreate ? 'password' : 'text'}
                    placeholder='Enter your password'
                    autoComplete='off'
                    className={'form-control form-control-lg form-control-solid'}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.currentTarget.value)
                    }}
                  />
                  <span
                    className='svg-icon svg-icon-3'
                    onClick={() => {
                      setShowPassword(!showPassword)
                    }}
                  >
                    {!showPassword && !isCreate ? (
                      <i className='bi bi-eye-fill'></i>
                    ) : (
                      <i className='bi bi-eye-slash-fill'></i>
                    )}
                  </span>
                </div>
              </Form.Group>
              <div className='d-flex justify-content-end'>
                <Button
                  data-testid='btnConfigureWebhookSecurity'
                  variant='primary'
                  disabled={writeLoading}
                  type='button'
                  size='sm'
                  onClick={(e) => handleSubmit()}
                >
                  {writeLoading ? <Spinner size='sm' /> : 'Configure'}
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default WebhookSecurity
